<div class="modal-header navbar-alertia">
    <h4 class="modal-title">{{'general.alert_status' | translate}}</h4>
    <button tabindex="0" type="button" title="{{ 'general.close_window' | translate }}" class="close" (click)="activeModal.close(false)">&times;</button>
</div>
<div class="modal-body">
    <div class="row">
        <div class="col-12 text-wrap text-break">
            {{'general.late_alerts_message' | translate}} <br>
            {{'general.late_alerts_unattended' | translate:{count: unattended} }} <br>
            {{'general.late_alerts_attending' | translate:{count: attending} }}
        </div>
    </div>
</div>
<div class="modal-footer text-right">
    <button type="button" title="Ok" class="btn btn-blue btn-h-blue" (click)="activeModal.close(false)">
        Ok
    </button>
</div>
